import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
function createAlert({
  message,
  options,
  title,
  type
}) {
  FloatingAlertStore.addAlert(Object.assign({
    message,
    titleText: title,
    type
  }, options));
}
export function alertSuccess({
  message,
  options,
  title
}) {
  createAlert({
    title: title || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkAssetPreviewLib.alerts.success.title"
    }),
    message,
    options,
    type: 'success'
  });
}
export function alertFailure({
  message,
  options,
  title
}) {
  createAlert({
    message: message || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkAssetPreviewLib.alerts.failure.message"
    }),
    options,
    title,
    type: 'danger'
  });
}